
import { Vue, Component } from "vue-property-decorator";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import ApplyForm from "@/components/ApplyForm.vue";
import FaqSection from "@/components/FaqSection.vue";
import coverImg from "@/assets/cover.jpg";
import curriculumImg from "@/assets/curriculum.jpg";
import learningImg from "@/assets/learning.jpg";
import alumniImg from "@/assets/alumni.jpg";

@Component({
  components: { Breadcrumb, ApplyForm, FaqSection }
})
export default class EmbaOverview extends Vue {
  coverImg = coverImg;
  curriculumImg = curriculumImg;
  learningImg = learningImg;
  alumniImg = alumniImg;
  List = [{ title: "共创会EMBA", url: "" }];

  breadcrumbList = [
    { name: "首页", url: "/" },
    { name: "关于光华" },
    { name: "共创会EMBA" }
  ];

  // FAQ 数据
  faqList = [
    { question: "共创会EMBA是什么？", answer: "光华共创会与香港光华管理学院联合发起的实战EMBA总裁班，旨在培养专业的企业老板，做中国最落地、最接地气的实战EMBA。" },
    { question: "共创会EMBA适合什么人？", answer: "面向企业负责人、联合创始人，希望系统学习经营管理实战课程的企业家群体。" },
    { question: "共创会EMBA有哪些特色？", answer: "实战、实操、实用、实效、实践，结合企业真实案例开展教学，注重落地执行与经营结果。" }
  ];
}
